import { render, staticRenderFns } from "./ItemsTable.vue?vue&type=template&id=f3c0a17c&scoped=true&"
import script from "./ItemsTable.vue?vue&type=script&lang=js&"
export * from "./ItemsTable.vue?vue&type=script&lang=js&"
import style0 from "./ItemsTable.vue?vue&type=style&index=0&id=f3c0a17c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c0a17c",
  null
  
)

export default component.exports